import React, { useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'
import { FilterActions, useFiltersContext } from '@/context/filters'
import { HomeQualityCheckStatus } from '@/types/HomeQualityCheck'

export const HomeQualityCheckStatusFilter = () => {
  const [{ homeQualityChecksFilters }, FilterDispatch] = useFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)

  const homeQualityCheckStatusOptions = Object.keys(HomeQualityCheckStatus).map((key) => {
    return { label: HomeQualityCheckStatus[key], value: HomeQualityCheckStatus[key] }
  })

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const onSelectFilter = (value?: HomeQualityCheckStatus) => {
    setDropdownExpanded(false)
    FilterDispatch(
      FilterActions.setFilters({
        filterName: 'homeQualityChecks',
        filters: {
          homeQualityCheckStatus: value,
        },
      }),
    )
  }

  return (
    <Dropdown
      className="mr-4 hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle="Status"
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!homeQualityChecksFilters['homeQualityCheckStatus']}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <ul>
          <li
            className={`${!homeQualityChecksFilters['homeQualityCheckStatus'] ? 'selected' : ''}`}
            onClick={() => onSelectFilter(undefined)}
            role={'presentation'}
          >
            All
          </li>
          {homeQualityCheckStatusOptions.map((val, i) => (
            <li
              className={`${val.value === homeQualityChecksFilters['homeQualityCheckStatus'] ? 'selected' : ''}`}
              key={i}
              onClick={() => onSelectFilter(val.value)}
              role={'presentation'}
            >
              {val.label}
            </li>
          ))}
        </ul>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
